module.exports = __webpack_public_path__ + "img/logo-xinxixi.5d9ec2d5.png";